import React from 'react';
import classnames from 'classnames';
import { isEmpty } from 'lodash';
import styles from './nearestOffers.module.css';

import NoFlightsBlock from './components/NoFlightsBlock';
import NearestOffersInfoBlock from './components/NearestOffersInfoBlock';
import NearestDeparturesBlock from './components/NearestDeparturesBlock';

import { NEAREST_OFFERS_CONTAINER_TEST_ID } from './constants';
import type { Departure, INearestOffers } from './types';

export const NearestOffers = (props: INearestOffers) => {
  const {
    nearestDeparturesData,
    nearestDatesData,
    isMobile,
    className = '',
  } = props;

  const { initial, result } = nearestDeparturesData || nearestDatesData || {};
  if (!initial || !result) return null;

  const isDeparture = 'departure' in result;
  const isDestinations = 'destinations' in result;
  const isDate = 'date' in result;

  const { nearestDepartures } = nearestDeparturesData ?? {};
  const departure = (
    isDeparture ? result.departure : initial.departure
  ) as Pick<Departure, 'nameForm2'>;

  const departureChanged = isDeparture && !isEmpty(result.departure);
  const destinationChanged = isDestinations && !isEmpty(result.destinations);
  const dateChanged = isDate && !isEmpty(result.date);

  const isNearestDeparturesBlock =
    !!nearestDepartures && !isEmpty(nearestDepartures);

  return (
    <div
      className={classnames(styles.wrapper, className)}
      data-testid={NEAREST_OFFERS_CONTAINER_TEST_ID}
    >
      <div
        className={classnames(styles.resultDepartureBlock, {
          [styles.resultDepartureBlockMobile]: isMobile,
        })}
      >
        <NoFlightsBlock
          initial={initial}
          destinationChanged={destinationChanged}
          departureChanged={departureChanged}
          dateChanged={dateChanged}
        />
        <br />
        <NearestOffersInfoBlock
          result={result}
          departure={departure}
          departureChanged={departureChanged}
          destinationChanged={destinationChanged}
          dateChanged={dateChanged}
          isMobile={isMobile}
        />
      </div>

      {isNearestDeparturesBlock && (
        <NearestDeparturesBlock
          departures={nearestDepartures}
          isMobile={isMobile}
        />
      )}
    </div>
  );
};
